<div class="auth-callback">
  <div class="auth-callback-progress-bar" >
  </div>
</div>
